import { format, parseUrlDate } from '../utils/date/dateUtils';
import { urlUtils } from '../utils/url';

export const priceCalendarModel = {
  get areaId() {
    const areaId = urlUtils.getAreaIdFromUrl();
    return areaId === '-1' ? '' : areaId;
  },
  get departureAirportId() {
    return urlUtils.getDepartureIdFromUrl();
  },
  get duration() {
    return urlUtils.getDurationFromUrl();
  },
  get fastestFlight() {
    const fastestFlightString = urlUtils.getFastestFlightFromUrl();
    if (fastestFlightString.toLowerCase() === 'true') {
      return true;
    }
    return false;
  },
  get resortId() {
    const resortId = urlUtils.getResortIdFromUrl();
    return resortId === '-1' ? '' : resortId;
  },
  get departureDate() {
    const departureDateFromUrl = urlUtils.getDepartureDateFromUrl();
    if (!departureDateFromUrl) return null;

    const departureDate = parseUrlDate(departureDateFromUrl);
    return format(departureDate, '-');
  },
  get returnDate() {
    const returnDateFromUrl = urlUtils.getReturnDateFromUrl();
    if (!returnDateFromUrl) return null;

    const returnDate = parseUrlDate(returnDateFromUrl);
    return format(returnDate, '-');
  },
  get rooms() {
    return urlUtils.getRoomDistributionFromUrl();
  },
};

export const packageModel = {
  get sessionId() {
    return urlUtils.getSessionIdFromUrl();
  },
  get rooms() {
    return urlUtils.getRoomDistributionFromUrl();
  },
  get departureAirportId() {
    return urlUtils.getDepartureIdFromUrl();
  },
  get resortId() {
    const resortId = urlUtils.getResortIdFromUrl();
    return resortId === '-1' ? '' : resortId;
  },
  get areaId() {
    const areaId = urlUtils.getAreaIdFromUrl();
    return areaId === '-1' ? '' : areaId;
  },
  get departureDate() {
    const departureDateFromUrl = urlUtils.getDepartureDateFromUrl();
    if (!departureDateFromUrl) return null;

    const departureDate = parseUrlDate(departureDateFromUrl);
    return format(departureDate, '-');
  },
  get returnDate() {
    const returnDateFromUrl = urlUtils.getReturnDateFromUrl();
    if (!returnDateFromUrl) return null;

    const returnDate = parseUrlDate(returnDateFromUrl);
    return format(returnDate, '-');
  },
  get duration() {
    return urlUtils.getDurationFromUrl();
  },
  get transportKey() {
    return urlUtils.getTransportKeyFromUrl();
  },
  get transportId() {
    return urlUtils.getTransportIdFromUrl();
  },
  get hotelId() {
    return urlUtils.getHotelIdFromUrl();
  },
  get accomodationKey() {
    return urlUtils.getAccommodationKeyFromUrl();
  },
  get roomGroupKey() {
    return urlUtils.getRoomGroupKeyFromUrl();
  },
  get bestPrice() {
    const bestPriceString = urlUtils.getBestPriceFromUrl();
    if (bestPriceString.toLowerCase() === 'true') {
      return true;
    }
    return false;
  },
  get fastestFlight() {
    const fastestFlightString = urlUtils.getFastestFlightFromUrl();
    if (fastestFlightString.toLowerCase() === 'true') {
      return true;
    }
    return false;
  },
  get tdmRuleId() {
    return urlUtils.getTdmRuleIdFromUrl();
  },
  get selectedCabin() {
    return urlUtils.getSelectedCabinFromUrl();
  },
  get selectedHotelCode() {
    return urlUtils.getSelectedHotelCodeFromUrl();
  },
  get price() {
    return urlUtils.getPriceFromUrl();
  },
  get isStandalone() {
    return urlUtils.getIsStandaloneFromUrl();
  },
  get tripContext() {
    return urlUtils.getTripContextFromUrl();
  },
  get cabinClass() {
    return urlUtils.getCabinClassFromUrl();
  },
  get directFlight() {
    return urlUtils.getDirectFlightFromUrl();
  },
  get includeBaggage() {
    return urlUtils.getIncludeBaggageFromUrl();
  },
};
